import { themeVars } from '@customerio/pluma-components/css/theme-tokens';
import { style } from '@vanilla-extract/css';

export const errorPreviewImage = style(
  {
    maxHeight: '100%',
    maxWidth: '100%',
    objectFit: 'contain',
    opacity: 0.5,
    borderRadius: themeVars.radius['3'],
  },
  'error-preview-image',
);

export const errorPreviewContainer = style(
  {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '65vh',
  },
  'error-preview-container',
);
